/* eslint-disable react/prop-types */
import { Box } from "@mui/material";
import React from "react";
import Typography from "../../../../components/common/new/Typography/Typography";
import GohonzonOtherInput from "../../../../components/GohonzonOtherInput/GohonzonOtherInput";
import { GOHONZON_SUBMISSION } from "../../../../contants/formFields";
import styles from "../GohonzonSubmission.styles";
import { SelectMonthAndYear } from "../../../../components/common/new/YearAndMonthDropDown/YearAndMonthDropDown";

function GohonzonOkatakiForm({
  values,
  handleChange,
  readOnly,
  setFieldValue,
}) {
  return (
    <Box mb={8}>
      <Box py="18px">
        <Box
          style={{
            width: "150px",
            height: "44px",
            flexShrink: "0",
            borderRadius: "35px",
            background: "#196AAB",
            marginBottom: "-35px",
            position: "relative",
            zIndex: "1",
            marginLeft: "45px",
          }}
        >
          <Typography
            variant="title3"
            style={{
              color: "#FFF",
              fontFeatureSettings: "'clig' off, 'liga' off",
              fontFamily: "Noto Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "600",
              lineHeight: "20px",
              padding: "12px 20px 12px 20px",
            }}
          >
            Other Details
          </Typography>
        </Box>
      </Box>
      <Box
        style={{
          borderRadius: "5px 5px 5px 5px",
          border: "1px solid #C2D4EB",
          background: "#F6F6F6",
          borderBottom: "9px solid #196AAB",
          margin: "0px 20px",
        }}
      >
        <Box style={styles.gridContainer}>
          <Box
            style={{
              width: "100%",
              padding: "10px 20px 20px 20px",
            }}
          />
          <Box
            style={{
              ...styles.gridItem,
              width: "100%",
              backgroundColor: "#ECECEC",
              padding: "10px 20px 10px 20px",
            }}
          >
            <Box style={{ display: "flex" }}>
              <Typography variant="mini" color="#5e5e5e" weight={600}>
                DURATION OF PRACTICE (Minimum 6 Months){" "}
                <Typography variant="small" color="#FF6A69">
                  *
                </Typography>
              </Typography>
            </Box>
            <Box width="45%" paddingLeft="10%">
              <SelectMonthAndYear
                name={GOHONZON_SUBMISSION.DURATION_OF_PRACTICE}
                value={values[GOHONZON_SUBMISSION.DURATION_OF_PRACTICE]}
                readOnly={readOnly}
                setFieldValue={setFieldValue}
                required
              />
            </Box>
          </Box>
          <Box
            style={{
              width: "100%",
              padding: "10px 20px 10px 20px",
            }}
          >
            <GohonzonOtherInput
              name={GOHONZON_SUBMISSION.REGULAR_GONGYO_DAIMOKU}
              value={values[GOHONZON_SUBMISSION.REGULAR_GONGYO_DAIMOKU]}
              handleChange={handleChange}
              preLabel="DOING REGULAR GONGYO & DAIMOKU"
              required
              readOnly={readOnly}
            />
          </Box>{" "}
          <Box
            style={{
              ...styles.gridItem,
              width: "100%",
              backgroundColor: "#ECECEC",
              padding: "10px 20px 10px 20px",
            }}
          >
            <GohonzonOtherInput
              name={GOHONZON_SUBMISSION.PERMISSION_TO_RECEIVE}
              value={values[GOHONZON_SUBMISSION.PERMISSION_TO_RECEIVE]}
              handleChange={handleChange}
              preLabel="PERMISSION TO RECEIVE AND ENSHRINE THE GOHONZON FROM FAMILY"
              required
              readOnly={readOnly}
            />
          </Box>{" "}
          <Box
            style={{
              width: "100%",
              padding: "10px 20px 10px 20px",
            }}
          >
            <GohonzonOtherInput
              name={GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED}
              value={values[GOHONZON_SUBMISSION.PLACE_OF_ENSHRINED]}
              handleChange={handleChange}
              preLabel="PROPOSED PLACE FOR ENSHRINING GOHONZON"
              buttonLabels={["Approved", "Not Approved"]}
              required
              readOnly={readOnly}
            />
          </Box>{" "}
        </Box>
      </Box>
    </Box>
  );
}

export default GohonzonOkatakiForm;
